import { Button, Input, useToast } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { RanaModal } from "@nens/ranalib";

import { getSimulationTemplatesApi } from "../../apiConfiguration";
import { Toast } from "../../components/Toast";

interface EditTemplateNameProps {
  isOpen: boolean;
  onClose: () => void;
  templateName: string;
  templateId: number;
}

export default function EditTemplateNameModal({
  isOpen,
  onClose,
  templateName,
  templateId,
}: EditTemplateNameProps) {
  const toast = useToast();
  const queryClient = useQueryClient();

  const showToast = (title: string, status: "error" | "success") => {
    toast({
      render: ({ onClose }) => <Toast {...{ title, status, onClose }} />,
      duration: 9000,
      isClosable: true,
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setTemplateName(event.target.value.toString());

  const [newTemplateName, setTemplateName] = useState(templateName);
  const simulationTemplatesApi = getSimulationTemplatesApi();

  const saveTemplateName = async () => {
    try {
      await simulationTemplatesApi.simulationTemplatesPartialUpdate({
        id: templateId,
        data: { name: newTemplateName },
      });

      queryClient.refetchQueries({ queryKey: ["simulationTemplates"] });
      showToast("Simulation template name saved", "success");
    } catch (error) {
      showToast("Something went wrong while saving the simulation template name", "error");
      console.log(error);
    }
    onClose();
  };

  return (
    <RanaModal
      isOpen={isOpen}
      onClose={onClose}
      topBar="Edit template name"
      buttons={[
        <Button variant="primary" key="save" style={{ float: "right" }} onClick={saveTemplateName}>
          Save
        </Button>,
      ]}
    >
      <Input placeholder="Template" size="sm" value={newTemplateName} onChange={handleChange} />
    </RanaModal>
  );
}
